var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"competition_model_title"},[_c('div',{staticClass:"title_icon"},[_c('img',{attrs:{"src":_vm.type === 0
          ? _vm.calendarIcon
          : _vm.type === 1
          ? _vm.homeZoneIcon
          : _vm.type === 2
          ?  _vm.overviewIcon
          : _vm.messageIcon,"alt":""}})]),_c('div',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }